import { frontendURL } from '../../../../helper/URLHelper';

const newReports = accountId => ({
  parentNav: 'newReports',
  routes: ['new_conversation_reports'],
  menuItems: [
    {
      icon: 'chat',
      label: 'REPORTS_CONVERSATION',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/new-reports/conversation`),
      toStateName: 'new_conversation_reports',
    },
  ],
});

export default newReports;
